// eslint-disable-next-line no-shadow
export enum BenefitStatus {
  REQUESTED = "REQUESTED",
  NOT_REQUESTED = "NOT_REQUESTED",
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
}

export default class Benefit {
  name;

  isActive;

  config;

  static status: BenefitStatus;

  constructor({
    name = "",
    isActive = false,
    config,
  }: {
    name?: string;
    isActive?: boolean;
    config?: any;
  }) {
    this.name = name;
    this.isActive = isActive;
    this.config = config;
  }

  modIsActive = () => new Benefit({ ...this, isActive: !this.isActive });

  modConfig = (config) => new Benefit({ ...this, config });

  public static isActive = () => Benefit.status === BenefitStatus.ACTIVE;
}
